import React, { useState, useRef } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { Popup } from '@progress/kendo-react-popup';
import { Button } from '@ui';
import './ConfigurationActionsStyles.scss';
import { translate } from '@utils/i18n';
const namespace = 'components.configuration_actions';
export default function ConfigurationActions() {
    const [open, setOpen] = useState(false);
    const anchor = useRef(null);
    const handleClose = () => {
        setOpen(false);
    };
    const handleTriggerClick = (e) => {
        e.stopPropagation();
        setOpen(!open);
    };
    const handlePopupClick = (e) => {
        e.stopPropagation();
    };
    const handleNavigate = (url) => (e) => {
        e.stopPropagation();
        window.open(url, '_blank', 'noopener,noreferrer');
        handleClose();
    };
    return (React.createElement("div", { className: "configuration-actions" },
        React.createElement(Button, { ref: anchor, variant: "default", onClick: handleTriggerClick, className: "configuration-actions__trigger", title: translate('options_title', { namespace }), type: "button" },
            React.createElement("i", { className: "fa-light fa-gear" }),
            translate('configure', { namespace })),
        React.createElement(Popup, { anchor: anchor.current, show: open, onClose: handleClose },
            React.createElement(ClickAwayListener, { onClickAway: handleClose },
                React.createElement("div", { className: "configuration-actions__popup", onClick: handlePopupClick, role: "dialog", "aria-label": translate('menu_aria_label', { namespace }) },
                    React.createElement("div", { className: "configuration-actions__header" },
                        React.createElement("span", { className: "configuration-actions__subtitle" }, translate('subtitle', { namespace }))),
                    React.createElement("ul", { role: "presentation", className: "configuration-actions__menu" },
                        React.createElement("li", { role: "presentation", className: "configuration-actions__menu-item" },
                            React.createElement(Button, { onClick: handleNavigate('/component_question_sets'), className: "configuration-actions__menu-button" }, translate('questions', { namespace }))),
                        React.createElement("li", { role: "presentation", className: "configuration-actions__menu-item" },
                            React.createElement(Button, { onClick: handleNavigate('/component_types'), className: "configuration-actions__menu-button" }, translate('types_and_compatibilities', { namespace }))),
                        React.createElement("li", { className: "configuration-actions__separator" }),
                        React.createElement("li", { role: "presentation", className: "configuration-actions__menu-item" },
                            React.createElement(Button, { onClick: handleNavigate('/all_settings'), className: "configuration-actions__menu-button" }, translate('settings', { namespace })))))))));
}
